export default __webpack_public_path__ + "static/icon-misc-d46269bf300294e4db3e3e765cc06218.svg";